<div [appOffClick]="closeDropDown">

  <indic-input [isClearAll]="settings.isClearAll" placeholder="{{settings.placeholder}}" [formControl]="inputValue"
    tabindex="-1" [inputOptions]="{keyboardPosition:settings.keyboardPosition}" [keyboard]="settings.keyboard">
  </indic-input>
  <div [style.display]="(settings.isForceVisible||isSpace)&&visible ? 'block' : 'none'" #divEl>
    <dropdown-container #dropDown [settings]="settings" class="dropdown-container" #container="dropDownContainer"
      [searchValue]="inputValue.value">
      <ul class="dropdown-menu " style="width: 100%;" *ngIf="!settings.isGroup">
        <li *ngFor="let option of options;trackBy: trackByFn;let i=index;" [dropdownItem]="option"
          (select)="setvalue($event)" id="{{option?.id}}" role="menuitem">
          <div class="drop-down-row">
            <a href="javascript:void(0)" tabindex="-1" class="dropdown-item">
              <div>
                {{option?.prefix}} {{option.name}} {{option?.suffix}}</div>
            </a>
          </div>
        </li>
      </ul>
      <ul class="dropdown-menu " style="width: 100%;" *ngIf="settings.isGroup">
        <ng-container *ngFor="let o of optionsGroup">

          <div class="dropdown-toolbar" [dropdownTitle]="o?.title">{{o?.title}}</div>
          <li *ngFor="let option of o?.options;trackBy: trackByFn;let i=index;" [groupBy]="o?.title"
            [dropdownItem]="option" (select)="setvalue($event)" id="{{option?.id}}" role="menuitem">
            <div class="drop-down-row">
              <a href="javascript:void(0)" tabindex="-1" class="dropdown-item">
                <div>
                  {{option?.prefix}} {{option.name}} {{option?.suffix}}</div>
              </a>
            </div>
          </li>
        </ng-container>
      </ul>
      <ng-container *ngIf="footerDetailsVisible&&!!footerDetails">
        <ng-container *ngTemplateOutlet="footerDetails"></ng-container>
      </ng-container>
    </dropdown-container>
  </div>
</div>